import { AType, summon } from "@silversea-ssc/functional-support"
import { PriceRequestV2 } from "../price"
import { QuoteProcessId } from "../quote-process-id"

export const QuoteSource = /* @__PURE__ */ summon((F) => F.keysOf({ PriceConfig: null, ECommerce: null }))
export type QuoteSource = AType<typeof QuoteSource>

export const CustomerInfo = summon((F) =>
    F.interface(
        {
            title: F.string(),
            firstName: F.string(),
            lastName: F.string(),
            email: F.string(),
            phone: F.string(),
            comments: F.nullable(F.string()),
        },
        "CustomerInfo",
    ),
)
export type CustomerInfo = AType<typeof CustomerInfo>

export const ValidateQuoteRequest = summon((F) =>
    F.interface(
        {
            id: QuoteProcessId(F),
            trackingId: F.string(),
            captchaSolution: F.string(),
            auid: F.string(),
            price: PriceRequestV2(F),
            customer: CustomerInfo(F),
            source: QuoteSource(F),
        },
        "ValidateQuoteRequest",
    ),
)
export type ValidateQuoteRequest = AType<typeof ValidateQuoteRequest>
